import { Project, ProjectSelectOption } from '@qality/common-model';
import { ProjectService } from '@qality/common-service';
import URLService from '@qality/server-services/src/URLService';

export const mapProjectsToSelectOptions = (
  projects: Array<Project>
): Array<ProjectSelectOption> => {
  return projects.map((project) => mapProjectToSelectOption(project));
};

export const mapProjectToSelectOption = (
  project: Project
): ProjectSelectOption => {
  return {
    label: `${project.name} (${project.key})`,
    value: project.id,
    name: project.name,
    id: project.id,
    key: project.key,
    iconUrl: URLService.getProjectAvatarUrl(project.id, project.icon.id),
  };
};

export const addProjectFromValue = (
  projectsArray: Array<ProjectSelectOption>,
  value: ProjectSelectOption
): Array<ProjectSelectOption> => {
  const projects = [...projectsArray];

  const project = projects.find(
    (projectItem) => projectItem.id.toString() === value.id
  );

  if (project) {
    return projects;
  }

  projects.push(value);

  return projects;
};

export const addProjectFromUrl = async (
  projectsArray: Array<ProjectSelectOption>,
  projectId: string
): Promise<{
  projects: Array<ProjectSelectOption>;
  project: ProjectSelectOption;
}> => {
  const projects = [...projectsArray];

  let project = projects.find(
    (projectItem) => projectItem.id.toString() === projectId
  );

  if (project) {
    return { projects, project };
  }

  project = await ProjectService.getProject(projectId);
  project = mapProjectToSelectOption(project);

  projects.push(project);

  return { projects, project };
};
